import Model from "@/lib/model/model";
import request from "@/lib/request/request";

// export class UserList extends Model{

// }
// export class UserList extends Model{

// }
export class ExamDepartment extends Model {
  no = ""; // 部门编号
  name = ""; // 部门名(0特殊处理为公司名)
  hasPermission = 0; // 是否拥有权限 0 1 2
}
export class DepartmentList extends Model {}
export class UserList extends Model {
  userId = 0; // 用户id
  nickname = ""; // 昵称
  mobile = ""; // 电话
  hasPermission = 0; // 是否拥有权限 0 1 2
}
export class PowerData extends Model {
  examDepartment = new ExamDepartment();
  departmentList: ExamDepartment[] = [new ExamDepartment()];
  userList: UserList[] = [new UserList()];
}

export default class Power extends Model {
  static get(param: any) {
    return request.post("/aiExam/permission/get", param).then(resp => {
      return new PowerData(resp).assign(resp.data.data);
    });
  }
  static tree(param: any) {
    return request
      .post("/aiExam/permission/departmentTree", param)
      .then(resp => {
        return resp?.data?.data;
      });
  }
  static getNode(param: any) {
    return request.post("/aiExam/permission/userList", param).then(resp => {
      return resp?.data?.data;
    });
  }
  static search(param: any) {
    return request.post("/aiExam/permission/allList", param).then(resp => {
      return resp?.data?.data;
    });
  }
  static set(param: any) {
    return request.post("/aiExam/permission/set", param).then(resp => {
      return resp?.data?.data;
    });
  }
}
